/**
 * db-cart-rewards.js
 * Live-update the free-shipping bar when cart contents change
 * (AJAX add-to-cart, quantity changes, item removal).
 *
 * Drop into assets/ and link from theme.liquid:
 *   {{ 'db-cart-rewards.js' | asset_url | script_tag }}
 *
 * Works alongside the Liquid snippet — it only activates if the widget
 * is rendered in the DOM (i.e. exclusion logic in Liquid already passed).
 */

(function () {
  'use strict';

  const SELECTOR = '[data-db-cart-rewards]';

  function updateWidget(widget, cartData) {
    const threshold = parseInt(widget.dataset.threshold, 10) || 0;
    if (!threshold) return;

    const current   = cartData.total_price || 0;
    const remaining = Math.max(0, threshold - current);
    let   progress  = threshold > 0 ? Math.min(100, Math.round((current / threshold) * 100)) : 0;

    /* ── Update data attrs ── */
    widget.dataset.current = current;

    /* ── Progress fill ── */
    const fill = widget.querySelector('[data-db-rewards-fill]');
    if (fill) fill.style.setProperty('--db-cart-progress', progress + '%');

    /* ── ARIA ── */
    const bar = widget.querySelector('[data-db-rewards-progressbar]');
    if (bar) bar.setAttribute('aria-valuenow', current);

    /* ── Message ── */
    const msgEl = widget.querySelector('[data-db-rewards-message]');
    if (!msgEl) return;

    if (remaining > 0) {
      /* Format remaining as money */
      const formatted = formatMoney(remaining, window.Shopify && window.Shopify.money_format);
      const template  = widget.dataset.awayTemplate || 'You\'re [amount] away from free shipping!';
      msgEl.innerHTML = template.replace('[amount]', '<strong data-db-rewards-remaining>' + formatted + '</strong>');
      widget.removeAttribute('data-unlocked');
    } else {
      const template = widget.dataset.unlockedTemplate || 'Free shipping is locked in!';
      msgEl.innerHTML = template;
      widget.setAttribute('data-unlocked', '');
    }
  }

  /**
   * Basic Shopify money formatter.
   * Respects window.Shopify.money_format when available.
   */
  function formatMoney(cents, format) {
    if (!format) format = '${{amount}}';
    const dollars = (cents / 100).toFixed(2);
    return format
      .replace('{{amount}}',      dollars)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', dollars.replace('.', ','));
  }

  /**
   * Fetch current cart and re-render all widgets on the page.
   */
  function refreshAll() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll(SELECTOR).forEach(function (widget) {
          updateWidget(widget, cart);
        });
      })
      .catch(function () { /* silently ignore network errors */ });
  }

  /* ── Listen for cart changes ──────────────────────────────────────────────── */

  /* Shopify AJAX API events (most themes emit these) */
  document.addEventListener('cart:updated',   refreshAll);
  document.addEventListener('cart:refresh',   refreshAll);
  document.addEventListener('cart:change',    refreshAll);

  /* Theme Kit / Dawn style events */
  document.addEventListener('cart-update',    refreshAll);

  /* Catch-all: intercept fetch/XHR to /cart/add.js etc. */
  const _fetch = window.fetch;
  window.fetch = function () {
    const url = arguments[0];
    if (typeof url === 'string' && /\/cart\/(add|change|update)\.js/.test(url)) {
      return _fetch.apply(this, arguments).then(function (response) {
        /* Clone so the original stream is still consumable by the caller */
        response.clone().json().then(refreshAll).catch(function () { refreshAll(); });
        return response;
      });
    }
    return _fetch.apply(this, arguments);
  };

  /* Initial paint if page loads with cart contents already present */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (document.querySelector(SELECTOR)) refreshAll();
    });
  } else {
    if (document.querySelector(SELECTOR)) refreshAll();
  }
})();